var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInspection11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22614",
    "data-name": "Group 22614",
    transform: "translate(8915 -5398)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1263",
    "data-name": "Ellipse 1263",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(-8915 5398)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16310",
    "data-name": "Path 16310",
    d: "M-1.432-.64V-5.072h1.28a2.342,2.342,0,0,1,.888.148,1.441,1.441,0,0,1,.588.432,1.756,1.756,0,0,1,.328.688,3.824,3.824,0,0,1,.1.916,3.261,3.261,0,0,1-.108.9,2.192,2.192,0,0,1-.276.62,1.444,1.444,0,0,1-.38.392,1.865,1.865,0,0,1-.428.22,1.8,1.8,0,0,1-.408.1,3.188,3.188,0,0,1-.32.02Zm-.76-5.072V0h1.96A3.429,3.429,0,0,0,1-.2a2.15,2.15,0,0,0,.856-.58,2.385,2.385,0,0,0,.5-.936,4.624,4.624,0,0,0,.16-1.276A2.691,2.691,0,0,0,1.8-5.04,2.848,2.848,0,0,0-.232-5.712Z",
    transform: "translate(-8909 5407)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspection11);
export default __webpack_public_path__ + "static/media/inspection_11.341bdbc93f742866810149b285e4daa7.svg";
export { ForwardRef as ReactComponent };